import { TFunction } from 'i18next'

// Define the error codes as constants for better type safety
export const ERROR_CODES = {
  ERR_ACCOUNT_ALREADY_EXISTS: 'ERR_ACCOUNT_ALREADY_EXISTS',
  ERR_ACCOUNT_NOT_FOUND: 'ERR_ACCOUNT_NOT_FOUND',
  ERR_BAD_REQUEST: 'ERR_BAD_REQUEST',
  ERR_EMAIL_EXISTS_UNDER_CHILD_ACCOUNT: 'ERR_EMAIL_EXISTS_UNDER_CHILD_ACCOUNT',
  ERR_FORBIDDEN: 'ERR_FORBIDDEN',
  ERR_INVALID_CREDENTIALS: 'ERR_INVALID_CREDENTIALS',
  ERR_INVALID_EMAIL_FORMAT: 'ERR_INVALID_EMAIL_FORMAT',
  ERR_INTERNAL_SERVER_ERROR: 'ERR_INTERNAL_SERVER_ERROR',
  ERR_RESOURCE_ALREADY_EXISTS: 'ERR_RESOURCE_ALREADY_EXISTS',
  ERR_TOO_MANY_REQUESTS: 'ERR_TOO_MANY_REQUESTS',
  ERR_UNAUTHORIZED: 'ERR_UNAUTHORIZED',
  ERR_UNKNOWN: 'ERR_UNKNOWN',
} as const

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES]

const errorMessages: Record<ErrorCode, string> = {
  [ERROR_CODES.ERR_ACCOUNT_ALREADY_EXISTS]: 'errors.accountAlreadyExists',
  [ERROR_CODES.ERR_ACCOUNT_NOT_FOUND]: 'errors.accountNotFound',
  [ERROR_CODES.ERR_BAD_REQUEST]: 'errors.badRequest',
  [ERROR_CODES.ERR_EMAIL_EXISTS_UNDER_CHILD_ACCOUNT]: 'errors.emailExistsUnderChildAccount',
  [ERROR_CODES.ERR_FORBIDDEN]: 'errors.forbidden',
  [ERROR_CODES.ERR_INVALID_CREDENTIALS]: 'errors.invalidCredentials',
  [ERROR_CODES.ERR_INVALID_EMAIL_FORMAT]: 'errors.invalidEmailFormat',
  [ERROR_CODES.ERR_INTERNAL_SERVER_ERROR]: 'errors.serverError',
  [ERROR_CODES.ERR_RESOURCE_ALREADY_EXISTS]: 'errors.resourceAlreadyExists',
  [ERROR_CODES.ERR_TOO_MANY_REQUESTS]: 'errors.tooManyRequests',
  [ERROR_CODES.ERR_UNAUTHORIZED]: 'errors.unauthorized',
  [ERROR_CODES.ERR_UNKNOWN]: 'errors.generic',
}

/**
 * Maps error codes to appropriate localized error messages under the "vpc" namespace with no key prefix.
 * @param errorCode - The application-specific error code
 * @param t - The translation function from react-i18next
 * @returns A localized error message
 */
export const getErrorMessage = (errorCode: ErrorCode, t: TFunction): string =>
  t(errorMessages[errorCode] || 'errors.generic')

const errorMatcher = {
  getErrorMessage,
}

export default errorMatcher
